export default __webpack_public_path__ + "static/ogp-550a594eea57cab43ff024497713bcc2.png";